export default {
  onlyOneTip:
    '同一のシーンには、1つのカルーセルコンポーネントしか追加できません。',
  direction: {
    vertical: '縦配置',
    horizontal: '横配置',
    label: '配置方法',
  },
  displayNum: {
    label: 'スロット数',
    title: 'カルーセルグループ',
    desc: 'もしスロットの数が5つで、中央のスロットを1番とする場合、左から右へのスロットの対応はそれぞれ、4、5、1、2、3になります。',
  },
  carouselSetting: '設定',
  carouselType: {
    normal: '通常',
    pulseScale: 'ズームイン / アウト',
    rollScale: 'スクロールズーム',
    opacity: 'フェードイン / アウト',
    opacityScale: 'フェードズーム',
  },
  playMode: {
    auto: '自動',
    manual: '手動',
    title: '再生設定',
  },
  triggerMode: {
    click: 'タップ',
    drag: 'ドラッグ',
    title: 'インタラクショ方式',
  },
  condition: {
    switchDone: {
      label: '切り替え時',
      tip: 'カルーセルが停止時に、対応するイベントをトリガーしてください。',
    },
    resourceSwitchDone: {
      label: '特定リソースへ',
      tip: '特定のリソースのカルーセル停止時に、対応するイベントをトリガーしてください。',
    },
    tagSwitchDone: {
      label: '特定のカテゴリへ',
      tip: '特定のカテゴリへ',
    },
  },
  component: {
    title: 'カルーセルコンポーネント',
    libTitle: 'カルーセル',
    add: {
      tips: '各シーンには1つのカルーセルコンポーネントしか追加できません。',
    },
    stayTime: {
      label: 'アニメーションの停止時間',
    },
    animationDuration: {
      label: 'アニメーションの再生時間',
    },
    displaySize: 'スロットサイズ',
    displaySpace: 'スロット間隔',
    style: {
      title: 'カルーセルスタイルの選択',
      selectTips: 'スタイルの選択',
    },
    group: {
      title: 'リソースグループ',
      add: 'カルーセルグループの追加',
    },
    pite: {
      setting: {
        title: 'スロット設定',
      },
      switch: {
        tips: '無効化するとカルーセルはスライド不可となり、内部のイベント効果も失われます。',
      },
    },
    method: {
      title: 'インタラクション方法',
    },
    extraSetting: {
      title: ' 詳細設定',
    },
    mask: {
      title: 'はみ出し時の切り取り',
      scale: 'クロップ',
      notScale: 'クロップなし',
    },
    resource: {
      title: 'リソース',
    },
    groupPreview: {
      title: {
        on: '取り消す',
        off: 'プレビューサイズ',
      },
    },
    scale: {
      title: 'スロット比率',
    },
  },
  tagManage: {
    title: 'リソースカテゴリ',
    tabTitle: 'カテゴリを選択する',
    select: {
      tips: 'イベントの成功または失敗のタイミングを決定するためのリソースカテゴリ',
    },
    desc: 'このカテゴリはカルーセルグループのリソースに適用されています。削除してもよろしいですか？',
    add: {
      label: 'カテゴリの追加',
    },
    delete: {
      tips: 'このカテゴリはカルーセルグループのリソースに適用されています。削除してもよろしいですか？',
    },
    tag: {
      name: {
        label: '名前',
      },
    },
  },
}
